@if (label) {
  @if (!url) {
    <span
      class="text-gray-500"
      [innerHTML]="label"></span>
  }
  @if (url) {
    <a
      class="text-gray-500 text-decoration-none"
      [href]="url"
      [innerHTML]="label"></a>
  }
}
